





























import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import rs from 'text-readability'

/**
 * TextArea component with text word-count and readability score
 *
 * Emits 'change' when text changes.
 */
@Component
export default class FancyTextArea extends Vue {
  @Prop() value!: string
  @Prop() title!: string
  @Prop() hint!: string
  @Prop({default: 10}) maxReadingLevel!: number
  @Prop() warnReadingLevel!: number // default: 90% of max
  @Prop({default: 100}) maxWordCount!: number
  @Prop() warnWordCount!: number // default: 90% of max

  actualWarnReadingLevel = 0
  actualWarnWordCount = 0
  wordCount = 0
  gradeLevel = 0
  currentValue = ""

  get gradeLevelDisplay(): string {
    let gradeLevelString = Math.floor(this.gradeLevel).toString()
    if (this.wordCount < 10)
      return `--`
    if (this.gradeLevel > 12)
      gradeLevelString = "13+"
    if (this.wordCount < 50 && this.gradeLevel > 8)
      return `(~${gradeLevelString})`
    else
      return gradeLevelString
  }
  isWordCountWarn() {
    return this.wordCount > this.actualWarnWordCount &&
      this.wordCount < this.maxWordCount
  }
  isWordCountLimit() {
    return this.wordCount >= this.maxWordCount
  }
  isReadingLevelWarn() {
    return this.wordCount > 50 &&
      this.gradeLevel > this.actualWarnReadingLevel &&
      this.gradeLevel < this.maxReadingLevel
  }
  isReadingLevelLimit() {
    return this.wordCount > 50 &&
      this.gradeLevel >= this.maxReadingLevel
  }
  setTextMetrics() {
    this.gradeLevel = rs.textMedian(this.currentValue)
    this.wordCount = rs.lexiconCount(this.currentValue)
  }

  input() {
    this.setTextMetrics()
    this.$emit('input', this.currentValue)
  }
  change() {
    this.$emit('change', this.currentValue)
  }
  @Watch('value')
  onValueUpdated(newVal: string) {
    this.currentValue = newVal
    this.setTextMetrics()
  }

  mounted() {
    this.currentValue = this.value
    this.setTextMetrics()
    this.actualWarnReadingLevel = this.warnReadingLevel ?
      this.warnReadingLevel : 0.9 * this.maxReadingLevel
    this.actualWarnWordCount = this.warnWordCount ?
      this.warnWordCount : 0.9 * this.maxWordCount
  }
}
